<div
  *ngIf="showConsent"
  class="fixed bottom-4 left-4 right-4 z-[2000] p-4 bg-yellow-200 max-w-xl text-black rounded-lg shadow-lg flex flex-col md:flex-row items-center justify-between"
>
  <p class="text-sm">
    We use cookies to personalize content, run ads and analyze our traffic.
    <a
      class="hover:text-blue-600"
      href="/terms-and-conditions"
      class="underline"
      >Learn more</a
    >
  </p>
  <div class="flex gap-2 ml-5 mt-2 md:mt-0 text-white">
    <button
      (click)="acceptCookies()"
      class="px-4 py-2 cursor-pointer bg-black hover:bg-green-500 hover:bg-green-600 rounded"
    >
      Accept
    </button>
    <button
      (click)="declineCookies()"
      class="px-4 py-2 cursor-pointer bg-black hover:bg-red-500 hover:bg-red-600 rounded"
    >
      Decline
    </button>
  </div>
</div>
